var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.$route.meta.isDialogPage)?_c('navbar'):_vm._e(),_c('v-main',{style:({'background-color':'#fafafa','padding-top':
    (!_vm.$route.meta.isDialogPage && !_vm.getSearchBar) ? '56px':'56px'}),attrs:{"id":"main-app"}},[_c('v-container',{attrs:{"pa-0":"","grid-list-lg":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }